var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigRedAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 51C38.8071 51 50 39.8071 50 26C50 12.1929 38.8071 1 25 1C11.1929 1 0 12.1929 0 26C0 39.8071 11.1929 51 25 51ZM25.0003 12.9045C23.6853 12.9045 22.6194 13.9705 22.6194 15.2855V30.7616C22.6194 32.0766 23.6853 33.1426 25.0003 33.1426C26.3153 33.1426 27.3813 32.0766 27.3813 30.7616V15.2855C27.3813 13.9705 26.3153 12.9045 25.0003 12.9045ZM27.3815 37.9044C27.3815 39.2193 26.3155 40.2853 25.0005 40.2853C23.6856 40.2853 22.6196 39.2193 22.6196 37.9044C22.6196 36.5894 23.6856 35.5234 25.0005 35.5234C26.3155 35.5234 27.3815 36.5894 27.3815 37.9044Z",
    fill: "#FF6262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigRedAlert);
export default __webpack_public_path__ + "static/media/Big Red Alert.67533da5fceca85b6a583ae62670cfc9.svg";
export { ForwardRef as ReactComponent };